import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000"

export const getOccupancyReport = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/report/occupancy`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching occupancy report:", error)
    throw error
  }
}

export const getCitiesDistribution = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/report/cities-distribution`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching cities distribution:", error)
    throw error
  }
}

export const getPropertyTypesDistribution = async (token) => {
  try {
    const response = await axios.get(
      `${API_URL}/report/property-types-distribution`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    return response.data
  } catch (error) {
    console.error("Error fetching property types distribution:", error)
    throw error
  }
}

export const getMonthlyEarnings = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/report/monthly-earnings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching monthly earnings:", error)
    throw error
  }
}

export const getPropertiesByOwner = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/report/properties-by-owner`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching properties by owner:", error)
    throw error
  }
}

export const getEarningsByOwner = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/report/earnings-by-owner`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching earnings by owner:", error)
    throw error
  }
}

export const getAdminEarnings = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/report/admin-earnings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching admin earnings:", error)
    throw error
  }
}
